var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VPageVue',{attrs:{"title":"สไลด์ Banner"}},[(_vm.mainBanner)?_c('BannerUpdateFormVue',{attrs:{"id":_vm.mainBanner.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }